/* Circular · cart drawer
   One file. Renders from /cart.js, mutates with /cart/change.js, and never waits for a
   network round trip before moving. The cross-domain bridge in layout/theme.liquid keeps
   the Storefront cart in step on its own poll, so nothing here needs to know about it. */
(function () {
  'use strict';

  var CFG = window.CX_CART || {};
  var money = function (c) {
    var f = CFG.moneyFormat || '${{amount}}';
    var v = (c / 100).toFixed(2);
    return f.replace(/\{\{\s*amount\s*\}\}/, v)
            .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(c / 100))
            .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.replace('.', ','));
  };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (m) {
    return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); };

  var state = {
    cart: (CFG.initialCart && CFG.initialCart.items) ? CFG.initialCart : null,
    open: false, busy: false, lastRemoved: null,
    /* Every local mutation bumps rev. A cart snapshot is only applied if the request
       that produced it STARTED after the last mutation — that is what stops a poll
       landing late and briefly resurrecting a line the shopper just deleted. */
    rev: 0
  };

  /* 8. analytics — the new drawer has to report what Dawn's used to */
  function track(name, payload) {
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, payload || {})); } catch (e) {}
    try {
      if (typeof fbq !== 'function') return;
      if (name === 'begin_checkout') fbq('track', 'InitiateCheckout', payload && payload.fb);
      else if (name === 'view_cart') fbq('trackCustom', 'ViewCart', payload && payload.fb);
    } catch (e) {}
  }
  function cartPayload(c) {
    if (!c) return {};
    return {
      currency: c.currency, value: (c.total_price || 0) / 100,
      items: (c.items || []).map(function (i) {
        return { item_id: i.sku || i.variant_id, item_name: i.product_title,
                 item_variant: i.variant_title, price: i.final_price / 100, quantity: i.quantity };
      }),
      fb: { value: (c.total_price || 0) / 100, currency: c.currency,
            content_ids: (c.items || []).map(function (i) { return i.variant_id; }), content_type: 'product' }
    };
  }
  /* 7. one polite announcement channel for screen readers */
  function say(msg) { if (el.live) el.live.textContent = msg; }
  var el = {};

  /* ---- shell ----------------------------------------------------------- */
  function build() {
    var veil = document.createElement('div');
    veil.className = 'cxc cxc-veil';
    veil.addEventListener('click', close);

    var panel = document.createElement('aside');
    panel.className = 'cxc cxc-panel';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-label', 'Your cart');
    panel.innerHTML =
      '<div class="cxc-hd"><h2>Your cart</h2><small data-c-count></small>' +
        '<button class="cxc-x" type="button" aria-label="Close cart">' +
        '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>' +
      /* 2026-08-21: free-shipping progress row REMOVED, matching the Webflow CX Cart.
         Shipping is not free and there is no threshold to count towards, so the bar had
         nothing truthful to show. The contextual upsell nudge lived inside this row and
         only ever appeared as "and shipping is on us", so it went with it — the in-body
         upsell (upsellHTML) is untouched. Do not reintroduce either. */
      '<div class="cxc-body" data-c-body></div>' +
      '<div class="cxc-ft" style="position:relative">' +
        '<div class="cxc-undo" data-c-undo><span></span><button type="button">Undo</button></div>' +
        '<div class="cxc-sum"><span>Subtotal</span><b data-c-total>—</b></div>' +
        '<p class="cxc-terms" data-c-terms></p>' +
        '<button class="cxc-go" type="button" data-c-go>Checkout</button>' +
        '<button class="cxc-view" type="button" data-c-view>View full cart</button>' +
        '<details class="cxc-disc"><summary>Discount code</summary>' +
          '<form data-c-disc><input type="text" name="discount" placeholder="Enter code" autocomplete="off"><button type="submit">Apply</button></form>' +
        '</details>' +
        '<div class="cxc-pay">' + (CFG.payments || ['Visa','Mastercard','Amex','PayPal','Apple Pay','Klarna'])
          .map(function (p) { return '<span>' + esc(p) + '</span>'; }).join('') + '</div>' +
      '</div>';

    document.body.appendChild(veil);
    document.body.appendChild(panel);

    el.veil = veil; el.panel = panel;
    el.body = panel.querySelector('[data-c-body]');
    el.count = panel.querySelector('[data-c-count]');
    el.total = panel.querySelector('[data-c-total]');
    el.terms = panel.querySelector('[data-c-terms]');
    el.undo = panel.querySelector('[data-c-undo]');
    el.live = document.createElement('p');
    el.live.className = 'cxc-live';
    el.live.setAttribute('role', 'status');
    el.live.setAttribute('aria-live', 'polite');
    panel.appendChild(el.live);

    panel.querySelector('.cxc-x').addEventListener('click', close);
    panel.querySelector('[data-c-go]').addEventListener('click', function () {
      track('begin_checkout', cartPayload(state.cart));
      window.location = (CFG.routes && CFG.routes.checkout) || '/checkout';
    });
    panel.querySelector('[data-c-view]').addEventListener('click', function () {
      window.location = (CFG.routes && CFG.routes.cart) || '/cart';
    });
    panel.querySelector('[data-c-disc]').addEventListener('submit', function (e) {
      e.preventDefault();
      var code = e.target.discount.value.trim();
      if (!code) return;
      window.location = '/discount/' + encodeURIComponent(code) + '?redirect=' +
        encodeURIComponent((CFG.routes && CFG.routes.cart) || '/cart');
    });
    el.undo.querySelector('button').addEventListener('click', undoRemove);

    /* focus trap + escape */
    document.addEventListener('keydown', function (e) {
      if (!state.open) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      var f = panel.querySelectorAll('button, input, a, summary, [tabindex]:not([tabindex="-1"])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  /* ---- render ---------------------------------------------------------- */
  function skeleton(n) {
    var out = '';
    for (var i = 0; i < (n || 2); i++) {
      out += '<div class="cxc-sk"><div class="cxc-sk__m"></div><div class="cxc-sk__b">' +
             '<span class="cxc-sk__l"></span><span class="cxc-sk__l"></span><span class="cxc-sk__l"></span></div></div>';
    }
    return out;
  }

  function variantLine(item) {
    var bits = (item.options_with_values || [])
      .map(function (o) { return o.value; })
      /* Shopify reports a single-variant product as Title / "Default Title". The old
         guard only covered the variant_title fallback, so "DEFAULT TITLE" printed under
         the Circular+ Guarantee. */
      .filter(function (v) { return v && v !== 'Default Title'; });
    if (!bits.length && item.variant_title && item.variant_title !== 'Default Title') bits = [item.variant_title];
    return bits.filter(Boolean).join(' · ');
  }

  function isKit(item) {
    var v = variantLine(item).toLowerCase();
    return v.indexOf('kit') > -1;
  }

  /* ---- LINE THUMBNAILS: RESOLVED FROM ALT TEXT, NOT FROM item.image ----------
     THE BUG (2026-08-28): every colour in the drawer showed the black ring wearing the
     "30% off" promo overlay. Nothing here was wrong — /cart.js `item.image` is the VARIANT's
     image, and Shopify falls back to the product's FEATURED image for any variant that has
     no image of its own. Only some variants are assigned, so most lines inherited the promo
     shot. Assigning all ~40 variants by hand in the admin would fix it, but the client
     manages this product's imagery through ALT TEXT (see the gallery in cx-ring-main.liquid,
     and shopify-patch/README-ALT-TEXT-KIT.md), so the drawer reads the same convention:

       alt contains the finish name        → that line's colour
       alt contains 'sizing kit'/'with kit'→ the kit shot
       alt contains 'no kit'/'without kit' → the ring alone

     A kit line prefers the kit shot, a ring line prefers the no-kit shot, and either falls
     back to a colour-only match and finally to item.image. So an untagged product still
     behaves exactly as before — this only ever improves on the fallback.

     ⚠ 'no kit' MUST be tested before 'sizing kit': it contains the substring 'kit'.
     ⚠ Purely numeric option values are SKIPPED when looking for the colour. Sizes are 6–14
       and alt text routinely contains digits ("Circular Ring 2"), so matching them would
       pick a thumbnail at random.
     ⚠ This never blocks the drawer. The first paint uses item.image; the media list is
       fetched once per product handle and render() is called again when it lands. */
  var mediaCache = {};

  function altPick(list, colour, wantKit) {
    var withAxis = null, colourOnly = null;
    for (var i = 0; i < list.length; i++) {
      var m = list[i];
      var a = (m.alt || '').toLowerCase();
      if (!a || (colour && a.indexOf(colour) === -1)) continue;
      if (!colourOnly) colourOnly = m.src;
      var noKit = a.indexOf('no kit') > -1 || a.indexOf('without kit') > -1;
      var isKitShot = !noKit && (a.indexOf('sizing kit') > -1 || a.indexOf('with kit') > -1);
      if (!withAxis && (wantKit ? isKitShot : noKit)) withAxis = m.src;
    }
    return withAxis || colourOnly || null;
  }

  function lineImage(item) {
    var list = mediaCache[item.handle];
    if (list && list.length) {
      var colour = null;
      (item.options_with_values || []).forEach(function (o) {
        var v = String(o.value || '').toLowerCase();
        if (!v || /^[0-9.\s]+$/.test(v) || v.indexOf('kit') > -1) return;
        for (var i = 0; i < list.length; i++) {
          if ((list[i].alt || '').toLowerCase().indexOf(v) > -1) { colour = v; return; }
        }
      });
      var hit = altPick(list, colour, isKit(item));
      if (hit) return hit;
    }
    return item.image || '';
  }

  /* one fetch per product handle, then a single re-render when the list arrives */
  function warmMedia() {
    var c = state.cart;
    if (!c || !c.items) return;
    c.items.forEach(function (item) {
      var h = item.handle;
      if (!h || mediaCache[h] !== undefined) return;
      mediaCache[h] = null;
      fetch('/products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          var list = (p && p.media ? p.media : []).filter(function (m) { return m && m.src; });
          if (!list.length) return;
          mediaCache[h] = list;
          render();
        })
        .catch(function () { /* keep item.image; never break the drawer over a thumbnail */ });
    });
  }

  function lineHTML(item) {
    var src = lineImage(item);
    var img = src ? src.replace(/(\.[a-z]+)(\?|$)/i, '_180x$1$2') : '';
    return '<div class="cxc-line" data-key="' + esc(item.key) + '">' +
      '<div class="cxc-line__m">' + (img ? '<img src="' + esc(img) + '" alt="" width="76" height="76" loading="lazy">' : '') + '</div>' +
      '<div class="cxc-line__b">' +
        /* 2026-10-11 agency CRO: product name links to its product page (item.url keeps the variant). */
        (item.url
          ? '<a class="cxc-line__t" href="' + esc(item.url) + '" style="color:inherit;text-decoration:none">' + esc(item.product_title) + '</a>'
          : '<span class="cxc-line__t">' + esc(item.product_title) + '</span>') +
        (variantLine(item) ? '<span class="cxc-line__v">' + esc(variantLine(item)) + '</span>' : '') +
        '<span class="cxc-line__p">' + money(item.final_line_price) +
          (item.original_line_price > item.final_line_price ? '<s>' + money(item.original_line_price) + '</s>' : '') +
        '</span>' +
        '<div class="cxc-line__r">' +
          '<span class="cxc-qty">' +
            '<button type="button" data-step="-1" aria-label="Reduce quantity">−</button>' +
            '<span data-q>' + item.quantity + '</span>' +
            '<button type="button" data-step="1" aria-label="Increase quantity">+</button>' +
          '</span>' +
          '<button class="cxc-rm" type="button" data-rm>Remove</button>' +
        '</div>' +
        (isKit(item) ? '<p class="cxc-note">We will email you to confirm your size before the ring ships.</p>' : '') +
      '</div></div>';
  }

  function upsellHTML() {
    var picks = (CFG.upsell || []).filter(function (p) {
      return !(state.cart && state.cart.items.some(function (i) { return String(i.product_id) === String(p.product_id); }));
    });
    if (!picks.length) return '';
    var p = picks[0];
    return '<div class="cxc-up"><div class="cxc-up__h">Often added</div><div class="cxc-up__i">' +
      (p.image ? '<img src="' + esc(p.image) + '" alt="" width="46" height="46" loading="lazy">' : '') +
      '<span><b>' + esc(p.title) + '</b><span>' + money(p.price) + '</span></span>' +
      '<button class="cxc-up__add" type="button" data-up="' + esc(p.id) + '">Add</button>' +
      '</div></div>';
  }

  function emptyHTML() {
    return '<div class="cxc-empty"><h3>Nothing here yet.</h3>' +
      '<p>The Ring 2 measures fourteen health signals from one finger, and every core feature is included.</p>' +
      '<a href="' + esc(CFG.productUrl || '/products/circular-ring-2') + '">Shop Circular Ring 2</a>' +
      '<ul>' +
        '<li><i></i><span>Worldwide shipping</span></li>' +
        '<li><i></i><span>14-day returns</span></li>' +
        '<li><i></i><span>No mandatory subscription</span></li>' +
      '</ul></div>';
  }

  function sig(c) {
    return !c ? '' : c.items.map(function (i) { return i.key + ':' + i.quantity + ':' + i.final_line_price; }).join('|');
  }

  function render() {
    /* resolves each line's thumbnail from alt text; see the note above lineImage() */
    warmMedia();
    var c = state.cart;
    /* ========================================================================
       render() has no veto. It draws whatever it is given, every time.

       It used to carry two suppression flags (expectEmptyUntil, and a busy reset) whose
       job was to stop a late poll flashing a removed line back. They caused far worse
       problems than they solved: after removing the last item the drawer refused to draw
       ANY non-empty cart for the next few seconds, so an immediate re-add looked like it
       had failed, and a stuck flag could suppress drawing indefinitely.

       Staleness is handled in exactly one place now — the rev counter in fetchCart() and
       change(), which discards responses that started before the newest mutation. That
       is the correct layer for it: reject bad DATA, never refuse to DRAW.
       ====================================================================== */
    if (!c) { el.body.innerHTML = skeleton(2); el.body.classList.remove('is-empty'); return; }

    /* nothing structural changed — update the numbers in place and leave the DOM alone */
    var s = sig(c);
    /* The in-place update is only safe when the SAME set of lines is on screen. Comparing
       a signature alone let a cart with different contents slip through as "unchanged"
       when a row was missing from the DOM. */
    var domKeys = [].map.call(el.body.querySelectorAll('.cxc-line'), function (n) { return n.getAttribute('data-key'); }).sort().join('|');
    var cartKeys = c.items.map(function (i) { return i.key; }).sort().join('|');
    if (s === render.last && domKeys && domKeys === cartKeys) {
      c.items.forEach(function (i) {
        var row = el.body.querySelector('[data-key="' + i.key + '"]');
        if (!row) return;
        row.querySelector('[data-q]').textContent = i.quantity;
        row.querySelector('.cxc-line__p').textContent = money(i.final_line_price);
      });
      el.total.textContent = money(c.total_price);
      return;
    }
    render.last = s;
    if (typeof keepScroll === 'number') el.body.scrollTop = keepScroll;

    el.body.classList.toggle('is-empty', !c.items.length);
    el.count.textContent = c.item_count ? c.item_count + (c.item_count === 1 ? ' item' : ' items') : '';
    el.total.textContent = money(c.total_price);

    if (!c.items.length) {
      el.body.innerHTML = emptyHTML();
      el.terms.textContent = '';
      el.panel.querySelector('[data-c-go]').style.display = 'none';
      el.panel.querySelector('[data-c-view]').style.display = 'none';
      el.total.textContent = money(0);
      return;
    }
    el.panel.querySelector('[data-c-go]').style.display = '';
    el.panel.querySelector('[data-c-view]').style.display = '';

    var keepScroll = el.body.scrollTop;
    var first = !el.body.querySelector('.cxc-line');
    el.body.classList.toggle('is-fresh', first);
    el.body.innerHTML = c.items.map(lineHTML).join('') + upsellHTML();
    if (!first) el.body.classList.remove('is-fresh');

    /* instalments */
    if (CFG.instalments && c.total_price > 0) {
      el.terms.textContent = 'Or 4 interest-free payments of ' + money(Math.round(c.total_price / 4)) + '.';
    } else { el.terms.textContent = ''; }
  }

  /* ---- data ------------------------------------------------------------- */
  var lastFetchAt = 0, lastFetchPromise = null;
  function fetchCart(force) {
    /* Coalesce: several things can ask for the cart at once (the completion event, the
       bridge broadcast, a visibility change). Reusing one in-flight read keeps us well
       under Shopify's rate limit instead of contributing to it. */
    var now = Date.now();
    if (lastFetchPromise && now - lastFetchAt < 600) return lastFetchPromise;
    lastFetchAt = now;
    var at = state.rev;
    /* A hung request used to leave the drawer on its loading skeleton indefinitely.
       Abort after six seconds so the caller can decide what to do. */
    var ctrl = ('AbortController' in window) ? new AbortController() : null;
    var killed = false;
    var timer = setTimeout(function () { killed = true; if (ctrl) ctrl.abort(); }, 4000);
    lastFetchPromise = fetch(((CFG.routes && CFG.routes.cart) || '/cart') + '.js',
        { credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) {
        if (r.status === 429) {
          if (window.console) console.warn('[cx] /cart.js throttled, backing off');
          return null;
        }
        return r.json();
      })
      .then(function (c) {
        clearTimeout(timer);
        if (!c) return state.cart;
        /* a mutation happened while this was in flight — its response is newer, so this
           snapshot is stale and must not repaint */
        if (!force && state.rev !== at) return state.cart || c;
        state.cart = c; render(); paintBadge(c.item_count); return c;
      })
      .catch(function (err) {
        clearTimeout(timer);
        if (window.console) console.warn('[cx] cart fetch failed', killed ? '(timed out)' : err);
        /* Show whatever we already have rather than a skeleton that never resolves. */
        if (state.cart) { render.last = null; render(); }
        throw err;
      })
      .finally(function () { setTimeout(function () { lastFetchPromise = null; }, 600); });
    return lastFetchPromise;
  }

  function change(key, qty) {
    state.busy = true;
    state.rev++;
    var at = state.rev;
    return fetch(((CFG.routes && CFG.routes.change) || '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) {
        if (r.status === 429) {
          /* throttled: keep the optimistic paint, resync shortly */
          setTimeout(function () { fetchCart(true).catch(function () {}); }, 2500);
          return state.cart;
        }
        return r.json();
      })
      .then(function (c) {
        if (!c || !c.items) return c;
        /* a newer mutation has since started; let that one paint */
        if (state.rev !== at) return c;
        state.cart = c; render(); paintBadge(c.item_count); notifyBridge(); return c;
      })
      /* always clear: gating this on "am I still the newest mutation" meant a
         superseded request left busy stuck true, which silently blocked later refreshes */
      .finally(function () { state.busy = false; });
  }

  function add(id, qty) {
    state.rev++;
    return fetch(((CFG.routes && CFG.routes.add) || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] })
    }).then(fetchCart).then(notifyBridge);
  }

  /* The cross-domain bridge mirrors /cart.js into the Storefront cart on its own poll;
     this only asks it to do so now rather than in up to 1.5s. */
  function notifyBridge() {
    state.selfChange = Date.now();
    try { window.postMessage({ type: 'UCART_CHANGED' }, '*'); } catch (e) {}
    document.dispatchEvent(new CustomEvent('cx:cart', { bubbles: true, detail: state.cart }));
  }

  function paintBadge(n) {
    document.querySelectorAll('[data-cx-cartcount], .ucart-badge').forEach(function (b) {
      b.textContent = n;
      b.classList.toggle('show', n > 0);
    });
  }

  /* ---- optimistic mutations -------------------------------------------- */
  var qTimers = {};
  function step(key, delta) {
    var line = el.body.querySelector('[data-key="' + key + '"]');
    var item = state.cart.items.filter(function (i) { return i.key === key; })[0];
    if (!line || !item) return;
    var next = Math.max(0, item.quantity + delta);
    if (next === 0) { remove(key); return; }

    /* paint immediately */
    item.quantity = next;
    if (next === 0) { line.classList.add('is-going'); }
    else {
      line.querySelector('[data-q]').textContent = next;
      line.querySelector('.cxc-line__p').textContent = money(Math.round(item.final_price * next));
    }
    say(item.product_title + ', quantity ' + next + '.');
    var sub = state.cart.items.reduce(function (s, i) { return s + i.final_price * i.quantity; }, 0);
    el.total.textContent = money(sub);

    clearTimeout(qTimers[key]);
    qTimers[key] = setTimeout(function () { change(key, next); }, 400);
  }

  function remove(key) {
    /* A pending debounced quantity write for this line would land AFTER the removal and
       recreate it. Cancel it first — this is the other half of the reappearing-line bug. */
    if (qTimers[key]) { clearTimeout(qTimers[key]); delete qTimers[key]; }
    var item = state.cart.items.filter(function (i) { return i.key === key; })[0];
    /* If the row exists on screen but not in state, the two have drifted. Re-fetch and
       remove against fresh data rather than returning silently — that silence was
       indistinguishable from a dead button. */
    if (!item) {
      fetchCart().then(function (c) {
        var again = (c.items || []).filter(function (i) { return i.key === key; })[0];
        if (again) remove(key);
      });
      return;
    }
    say(item.product_title + ' removed from your cart.');
    track('remove_from_cart', { currency: state.cart.currency, value: item.final_line_price / 100,
      items: [{ item_id: item.sku || item.variant_id, item_name: item.product_title, quantity: item.quantity }] });
    state.lastRemoved = { id: item.variant_id, qty: item.quantity, title: item.product_title };
    state.cart.items = state.cart.items.filter(function (i) { return i.key !== key; });
    state.cart.item_count = state.cart.items.reduce(function (s, i) { return s + i.quantity; }, 0);
    state.cart.total_price = state.cart.items.reduce(function (s, i) { return s + i.final_price * i.quantity; }, 0);
    render();
    paintBadge(state.cart.item_count);
    change(key, 0);
    el.undo.querySelector('span').textContent = 'Removed ' + item.product_title + '.';
    el.undo.classList.add('is-on');
    clearTimeout(remove.t);
    remove.t = setTimeout(function () { el.undo.classList.remove('is-on'); }, 4500);
  }

  function undoRemove() {
    if (!state.lastRemoved) return;
    var r = state.lastRemoved;
    state.lastRemoved = null;
    el.undo.classList.remove('is-on');
    add(r.id, r.qty);
  }

  /* ---- open / close ---------------------------------------------------- */
  /* set by any real interaction on this page */
  var userActed = false, bootAt = Date.now();
  ['pointerdown','keydown','touchstart'].forEach(function (ev) {
    document.addEventListener(ev, function () { userActed = true; }, { capture: true, passive: true });
  });

  function open(force) {
    /* Nothing may open the drawer before the visitor has acted. Landing on a product page
       from a link used to open it on arrival — and only on arrival, never on reload,
       because a reload has no inbound cart activity to react to. Refresh the data, keep
       the panel shut. */
    if (!force && !userActed && Date.now() - bootAt < 6000) {
      if (!state.cart) fetchCart().catch(function () {});
      return;
    }
    return openNow();
  }
  function openNow() {
    if (!el.panel) build();
    state.open = true;
    if (el.veil && !el.veil.isConnected) document.body.appendChild(el.veil);
    if (el.veil) { el.veil.hidden = false; requestAnimationFrame(function () { el.veil.classList.add('is-on'); }); }
    try { sessionStorage.setItem('cx:cartSeen', '1'); } catch (e) {}
    track('view_cart', cartPayload(state.cart));
    /* Only the genuinely-unknown case gets a skeleton. A known-empty cart shows the
       empty state, which render() handles. */
    /* Always draw on open. The first open of a session could show the footer over an
       empty body: the panel was built, but nothing had drawn into it yet. Forcing a
       render here means the drawer is never framed around nothing. */
    render.last = null;
    if (state.cart) render();
    else el.body.innerHTML = skeleton(2);
    el.veil.classList.add('is-on');
    el.panel.classList.add('is-on');
    document.documentElement.style.overflow = 'hidden';
    el.panel.querySelector('.cxc-x').focus({ preventScroll: true });
    fetchCart();
  }
  function close() {
    state.open = false;
    if (el.veil) el.veil.classList.remove('is-on');
    if (el.panel) el.panel.classList.remove('is-on');
    document.documentElement.style.overflow = '';
  }

  /* 10. a cart left from a previous visit opens itself once, quietly */
  (function reopen() {
    var seen = true;
    try { seen = sessionStorage.getItem('cx:cartSeen') === '1'; } catch (e) {}
    if (seen) return;
    fetch(((CFG.routes && CFG.routes.cart) || '/cart') + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        if (!c || !c.item_count) { try { sessionStorage.setItem('cx:cartSeen', '1'); } catch (e) {} return; }
        state.cart = c;
        setTimeout(function () { if (!state.open) open(); }, 1200);
      }).catch(function () {});
  })();

  /* ---- events ---------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    if (state.open && el.panel && !e.target.closest('.cxc-panel') &&
        !e.target.closest('.wf-open-cart, .cxn-cart, [data-cx-open-cart], #cart-icon-bubble')) {
      close();
      return;
    }
    var toggleBtn = e.target.closest(
      '.wf-open-cart, .cxn-cart, [data-cx-open-cart], #cart-icon-bubble, ' +
      'a[href$="/cart"], a[href$="/cart/"], summary[aria-label*="cart" i], [aria-controls="CartDrawer"]'
    );
    if (toggleBtn && state.open) {
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      close();
      return;
    }
    var openBtn = e.target.closest(
      '.wf-open-cart, .cxn-cart, [data-cx-open-cart], #cart-icon-bubble, ' +
      'a[href$="/cart"], a[href$="/cart/"], summary[aria-label*="cart" i], [aria-controls="CartDrawer"]'
    );
    if (openBtn && !e.target.closest('.cxc-panel')) {
      e.preventDefault();
      e.stopImmediatePropagation();      /* keep Dawn's own drawer from opening */
      open();
      return;
    }
  }, true);

  document.addEventListener('click', function (e) {
    if (!el.panel) return;
    var s = e.target.closest('[data-step]');
    if (s) { step(s.closest('[data-key]').getAttribute('data-key'), Number(s.getAttribute('data-step'))); return; }
    var rm = e.target.closest('[data-rm]');
    if (rm) { remove(rm.closest('[data-key]').getAttribute('data-key')); return; }
    var up = e.target.closest('[data-up]');
    if (up) { up.disabled = true; up.textContent = 'Adding…'; add(up.getAttribute('data-up'), 1); return; }
  });

  /* Dawn's drawer opens from its own element binding, which is attached when the custom
     element upgrades — before any listener we add. Racing it is unreliable, so we take its
     open methods away and reopen ours instead. The element stays in the DOM so Dawn's
     other code (and any app reading it) keeps working. */
  function muzzleDawn() {
    document.querySelectorAll('cart-drawer, cart-notification').forEach(function (d) {
      if (d.__cxMuzzled) return;
      d.__cxMuzzled = true;
      ['open', 'show', 'openDrawer'].forEach(function (m) {
        if (typeof d[m] === 'function') d[m] = function () { open(); };
      });
      /* if anything forces the class on regardless, strip it and open ours */
      /* Dawn toggles these classes on its own drawer during boot and on some page
         loads, and mirroring that blindly made our drawer open by itself. Only mirror
         an open that follows a real interaction, and never in the first second. */
      var ready = false;
      setTimeout(function () { ready = true; }, 1000);
      document.addEventListener('pointerdown', function () { state.touched = Date.now(); }, true);
      document.addEventListener('keydown', function () { state.touched = Date.now(); }, true);
      new MutationObserver(function () {
        if (d.classList.contains('active') || d.classList.contains('is-open') || d.hasAttribute('open')) {
          d.classList.remove('active', 'is-open');
          d.removeAttribute('open');
          var userDriven = state.touched && Date.now() - state.touched < 1500;
          if (ready && userDriven && !state.open) open();
        }
      }).observe(d, { attributes: true, attributeFilter: ['class', 'open'] });
    });
    /* Dawn's header uses <details> for the cart on some layouts — stop it natively */
    document.querySelectorAll('details#Details-CartDrawer, details[id*="Cart"]').forEach(function (dt) {
      dt.addEventListener('toggle', function () { if (dt.open) { dt.open = false; open(); } });
    });
  }
  muzzleDawn();
  document.addEventListener('shopify:section:load', muzzleDawn);
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('cart-drawer').then(muzzleDawn).catch(function () {});
  }

  /* Dawn's drawer stays in the DOM but must never show itself */
  var hide = document.createElement('style');
  hide.textContent = 'cart-drawer:not(.cxc){display:none!important}' +
    'cart-notification{display:none!important}';
  document.head.appendChild(hide);

  /* one catch-up when the tab comes back, instead of polling throughout */
  document.addEventListener('visibilitychange', function () {
    if (document.hidden || !state.missedWhileHidden) return;
    state.missedWhileHidden = false;
    if (!state.busy) fetchCart();
  });

  /* ---- the product page adds items itself; these two events drive the drawer ---- */
  /* Work has STARTED. Open at once and show one quiet indicator over whatever is
     already in the cart. No guessed placeholder rows: the page may add several items by
     several routes, and rendering a count we had to predict is what left stale skeletons
     sitting under a finished cart. */
  var addingTimer = null;
  document.addEventListener('cx:adding', function () {
    open();
    if (!el.body) return;
    el.body.classList.add('is-adding');
    /* Belt and braces: if the completion event never arrives for any reason, the working
       state clears itself. A spinner that can outlive its cause is worse than no spinner. */
    clearTimeout(addingTimer);
    addingTimer = setTimeout(function () {
      el.body.classList.remove('is-adding');
      fetchCart(true).catch(function () {});
    }, 7000);
  });

  /* Work has FINISHED and nothing further will change. One authoritative read. */
  document.addEventListener('cx:added', function () {
    clearTimeout(addingTimer);
    open();
    render.last = null;
    fetchCart(true)
      .catch(function () {})
      .then(function () { if (el.body) el.body.classList.remove('is-adding'); });
  });

  /* settleAfterAdd() removed 2026-08-22. It polled /cart.js repeatedly, guessing at
     when the page had finished adding, and stopped as soon as the count moved at all —
     so a multi-item add left the drawer showing the first item and nothing else. The
     product page now fires cx:added exactly once, when it is genuinely done. */
  window.addEventListener('message', function (e) {
    if (!e || !e.data || e.data.type !== 'UCART_CHANGED' || !state.open) return;
    if (state.selfChange && Date.now() - state.selfChange < 2500) return;  /* our own echo */
    if (state.busy) return;                       /* never repaint over a live mutation */
    /* The shared bridge broadcasts every 1.5s for as long as the page is open. Answering
       it in a background tab burns a request and a render for something nobody is
       looking at; the visibilitychange handler below catches up on return. */
    if (document.hidden) { state.missedWhileHidden = true; return; }
    fetchCart();
  });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible' && state.open) fetchCart();
  });

  /* prime the markup on first intent so opening is instant */
  ['pointerover', 'touchstart'].forEach(function (ev) {
    document.addEventListener(ev, function once(e) {
      if (!e.target.closest || !e.target.closest('.wf-open-cart, .cxn-cart, [data-cx-open-cart]')) return;
      if (!el.panel) build();
      /* revalidate even when seeded from Liquid: the page may have been sitting open,
         or another tab may have changed the cart */
      fetchCart();
      document.removeEventListener(ev, once);
    }, { passive: true });
  });

  /* Warm the cart once the page is idle.
     The badge count is rendered by Liquid, so nothing used to populate state.cart until
     the drawer was opened — which meant the first open always showed the skeleton for a
     full /cart.js round trip. Prefetching on idle makes that first open paint instantly.
     Idle, not load, so it never competes with the product imagery. */
  (function warmCart() {
    var go = function () { if (!state.cart && !state.busy) fetchCart(); };
    if (document.readyState === 'complete') {
      if ('requestIdleCallback' in window) requestIdleCallback(go, { timeout: 2500 });
      else setTimeout(go, 700);
    } else {
      window.addEventListener('load', function () {
        if ('requestIdleCallback' in window) requestIdleCallback(go, { timeout: 2500 });
        else setTimeout(go, 700);
      });
    }
  })();

  window.CXCart = {
    open: function () { return open(true); },   /* an explicit API call is deliberate */
    close: close, refresh: fetchCart, add: add
  };
})();
